import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class ZuordnungWaermeerzeugerWarmwasser extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    waermeerzeuger_warmwasser_id: number | null = null;
    energie_waermequelle_id: number | null = null;
    technologie_waermeerzeugung_id: number | null = null;
    reihenfolge: number | null = null;
    bemerkung: string | null = null;

    // view fields:
    waermeerzeuger_warmwasser: string | null = null;
    energie_waermequelle_i18n_key: string | null = null;
    technologie_waermeerzeugung_i18n_key: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'ZuordnungWaermeerzeugerWarmwasser';
    }
}

export async function createNewZuordnungWaermeerzeugerWarmwasser(): Promise<ZuordnungWaermeerzeugerWarmwasser> {
    const model = createModel(ZuordnungWaermeerzeugerWarmwasser, {});

    await model.save();
    return model;
}

export class ZuordnungWaermeerzeugerWarmwasserCollection extends BaseCollection<ZuordnungWaermeerzeugerWarmwasser> {
    protected modelCls = ZuordnungWaermeerzeugerWarmwasser;

    public getModelClassName(): string {
        return 'ZuordnungWaermeerzeugerWarmwasser';
    }
}
